module.exports = __webpack_public_path__ + "static_pc/img/test2.d9d7102e.jpg";